import { createContext, useContext, useState, useEffect } from "react";

// Create UserContext
const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [setting, setSetting] = useState(null);
  const [user, setUser] = useState(null);

  // Check if the user is already logged in (e.g., from localStorage)
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedSetting = localStorage.getItem("setting");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    if (storedSetting) {
      setSetting(JSON.parse(storedSetting));
    }


  }, []);

  // Function to login
  const loginUser = (userData, settingData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
    if (settingData) {
      setSetting(settingData);
      localStorage.setItem("setting", JSON.stringify(settingData));
    }

  };

  // Function to logout
  const logoutUser = () => {
    setUser(null);
    setSetting(null);
    localStorage.removeItem("user");
    localStorage.removeItem("setting");
  };

  const setNewSetting = (settingData) => {
    if (settingData) {
      setSetting(settingData);
      localStorage.setItem("setting", JSON.stringify(settingData));

    }
  };

  return (
    <UserContext.Provider value={{ user, loginUser, logoutUser, setting, setNewSetting }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to use UserContext
export const useUser = () => {
  return useContext(UserContext);
};
